import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useBookingDispatch } from "../../hooks/useBookingState";
import { RootState } from "../../store/store";
import {
  BookVal,
  extractFreeForAgesProductIds,
  extractInvalidAgeProductIds,
} from "../../utils/bookingUtils";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import QuantityCardForPass from "../QuantityCardForPass";
import { SelectChildAge } from "../SelectChildAge";

const passDefaultAgeQuantity: AgeQuantityDTO = {
  age: "ADULT",
  quantity: 1,
};

const QuantityBookCardSectionAges: React.FC<
  {
    type?: "ROW" | "CARD";
  } & ProdAttrPickerModeProps
> = ({ type = "ROW", ...props }) => {
  const [isAdult, setIsAdult] = useState(true);
  const [count, setCount] = useState(1);
  const isPass = props.d?.productType === "PASS";
  const { bookingPick, bookingPickLs, deSelectChildProducts } =
    useBookingDispatch({ mode: "FORM" });
  const booking = useSelector((state: RootState) => state.booking);
  const bookingAttributes = booking.bookingAttributes;

  const defaultBooka = ProdAttrUtils.findDefaultBooka(bookingAttributes);

  useEffect(() => {
    if (isPass) {
      setCount(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdult]);

  useEffect(() => {
    if (
      isAdult &&
      defaultBooka &&
      !defaultBooka?.value?.ageQuantities?.length
    ) {
      //default 1 adult

      const x = BookVal.append(defaultBooka)({
        ageQuantities: [passDefaultAgeQuantity],
      });
      if (x) {
        bookingPick(x);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultBooka, isAdult]);
  useEffect(
    function () {
      if (!isAdult && booking) {
        const invalidAgeProductIds = extractInvalidAgeProductIds(
          booking,
        ).filter((x) => x) as number[];
        const freeForAgesProductIds = extractFreeForAgesProductIds(booking);

        const merged = [
          ...invalidAgeProductIds,
          ...freeForAgesProductIds,
        ].filter((x, i, a) => a.indexOf(x) === i);

        if (merged.length > 0) {
          deSelectChildProducts({
            productIds: merged,
          });
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAdult, booking],
  );
  if (!defaultBooka) {
    return null;
  }
  if (isPass) {
    return (
      <>
        <QuantityCardForPass
          disabled={props.disabled}
          minQuantity={1}
          value={count}
          onChange={(quantity, age) => {
            setCount(quantity);
            setIsAdult(age === "ADULT");

            const ageValue = (function () {
              if (age === "ADULT") {
                return "ADULT";
              } else {
                return (
                  defaultBooka?.value?.ageQuantities?.filter(
                    (x) => x.age !== "ADULT",
                  )?.[0]?.age || ""
                );
              }
            })();

            const x = BookVal.append(defaultBooka)({
              ageQuantities: ageValue
                ? [
                    {
                      age: ageValue,
                      quantity: quantity || 1,
                    },
                  ]
                : [],
            });
            x && bookingPick(x);
          }}
        />

        {!isAdult && (
          <SelectChildAge
            singleMode={true}
            disabled={props.disabled}
            ages={Array(13)
              .fill(null)
              .map((_, index) => index)}
            ageQuantities={defaultBooka?.value?.ageQuantities}
            onChange={(ls: AgeQuantityDTO[]) => {
              const x = defaultBooka
                ? {
                    ...defaultBooka,
                    value: {
                      ageQuantities: ls.map((x) => ({
                        ...x,
                        quantity: x.quantity || count,
                      })),
                    },
                  }
                : null;
              x && bookingPick(x);
            }}
          />
        )}
        {/* {JSON.stringify(defaultBooka)} */}
      </>
    );
  }
  const childAge = bookingAttributes.filter(
    (x) => x.productAttribute.name === "CHILD",
  );
  if (childAge.length === 0) {
    return null;
  }
  const ages = childAge
    .flatMap((x) => {
      const a = ProdAttrUtils.CHILD.parseAge(x.productAttribute.value);

      if (
        a?.ageFrom === undefined ||
        a?.ageFrom === -1 ||
        a?.ageTo === undefined ||
        a?.ageTo === -1
      ) {
        return [];
      }
      return Array.from(
        { length: a.ageTo - a.ageFrom + 1 },
        (_, i) => a.ageFrom + i,
      );
    })
    .filter((x, _, a) => a.indexOf(x) !== -1)
    .sort();
  if (!ages.length) {
    return null;
  }

  return (
    <>
      <SelectChildAge
        ages={ages}
        disabled={props.disabled}
        ageQuantities={defaultBooka?.value?.ageQuantities}
        onChange={(ageQuantities: AgeQuantityDTO[]) => {
          const ls = [
            BookVal.append(defaultBooka)({
              ageQuantities,
            }),
            ...childAge.map((bean) =>
              BookVal.overwrite(bean)(
                (function () {
                  const count = ageQuantities
                    .filter((kk) =>
                      ProdAttrUtils.CHILD.includeAge(
                        bean.productAttribute.value,
                        kk.age,
                      ),
                    )
                    .reduce((a, b) => a + b.quantity, 0);
                  if (count === 0) return undefined;
                  return {
                    quantity: count,
                  };
                })() as BookingAttributeValueDTO,
              ),
            ),
          ].filter((x) => x) as BookingAttributeDTO[];
          bookingPickLs(ls);
        }}
      />
    </>
  );

  // return (
  //   <>
  //     {childAge.map((bean) => {
  //       return (
  //         <QuatityBookingRow
  //           key={bean.productAttribute.id}
  //           type={type}
  //           dto={bean}
  //           label={prodaName(bean.productAttribute)}
  //         />
  //       );
  //     })}
  //   </>
  // );
};

export default QuantityBookCardSectionAges;
